<template>
<div>
    <!-- modal -->
    <b-modal id="lawServiceLogListFormModal" centered size="lg" no-close-on-backdrop ref="lawServiceLogListFormModal" :title="$t('lawLedes.change_history')" hide-footer>
        <vue-good-table id="lawServiceLogListTable" ref="lawServiceLogListTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" theme="my-theme">
            <div slot="emptystate">
                {{ $t('dataTable.data_not_found') }}
            </div>
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'date'">
                    {{ $formatFn(props.row.date) }}
                </span>
            </template>
        </vue-good-table>
    </b-modal>
</div>
</template>

<script>
export default {
    data() {
        return {
            columns: [
                {
                    label: this.$t('lawLedes.log_date'),
                    field: 'date',
                },
                {
                    label: this.$t('lawLedes.log_employee'),
                    field: 'employeeName',
                },
                {
                    label: this.$t('lawLedes.log_body'),
                    field: 'body',
                },
            ],
            rows: [],
        }
    },
    methods: {
        showInfo(clientAccountingId) {
            this.$refs['lawServiceLogListFormModal'].show()
            this.rows = []
            const data = {
                id: clientAccountingId
            }
            const controller = {
                name: 'LawService',
                actionName: 'GetLogListByClientAccountingId'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.rows = response.data.logList
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
